export const TRANSACTION_DETAIL_TYPE_SUCCESS_BOOKING = 'SUCCESS';
export const TRANSACTION_DETAIL_TYPE_VIEW_TRANSACTION = 'VIEW_TRANSACTION';
